import ModalImport from '../../../../../Features/Modal/ModalImport';
import {importExcel2} from '../../service';
import {ProModalProps} from '../../../../../Components/ProModal';

export function ImportExcel2Modal({onOk, ...props}: ProModalProps) {
    async function onUpload(file: File) {
        await importExcel2(file);
        onOk?.();
    }

    return (
        <ModalImport
            {...props}
            title="Excel导入功能数据"
            onUpload={onUpload}
            templateUrl={require('./【导入模板】Excel 导入功能数据 V0.1.xlsx')}
            templateName="功能数据导入模板"
            restSteps={['2. 在导入模板补充好数据后上传文件']}
        />
    );
}
